import { heroStats, siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[92vh] w-full flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20lush%20watermelon%20field%20at%20golden%20hour%20with%20floating%20speech%20bubbles%20and%20sparkles%2C%20deep%20green%20foliage%20contrasting%20with%20warm%20cream%20sky%2C%20stylized%20painterly%20texture%2C%20editorial%20poster%20composition&width=1800&height=1100&seq=guitian-hero-2026&orientation=landscape"
          alt="瓜田插画：黄昏下的西瓜田与漂浮的对话气泡"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/45 to-black/55" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-5xl mx-auto flex flex-col items-center text-center fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm backdrop-blur-sm border border-background-50/20">
            <i className="ri-fire-line text-accent-300" />
            今日瓜田已上新 · 围观心理学特辑
          </span>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-7xl text-background-50 mt-6 md:mt-8 leading-tight">
            {siteInfo.name}
          </h1>

          <p className="mt-4 md:mt-6 text-lg md:text-2xl text-background-100 font-medium">
            {siteInfo.slogan}
          </p>

          <p className="mt-4 md:mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
            吃瓜不只八卦，还有让人停不下来的心理快感。日常段子、表情包、冷知识持续更新，顺便解析围观群众的心态与快乐来源，越吃越有趣。
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-emotion-laugh-line" />
              进入今日瓜田
            </a>
            <a
              href="#psych"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-background-50/12 text-background-50 text-sm md:text-base backdrop-blur-sm border border-background-50/25 hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-mental-health-line" />
              看看吃瓜心理学
            </a>
          </div>

          <dl className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 w-full max-w-3xl">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center">
                <dt className="font-heading text-2xl md:text-3xl text-accent-300">{stat.value}</dt>
                <dd className="mt-1 text-xs md:text-sm text-background-200">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <a
        href="#hot"
        aria-label="向下滚动查看今日瓜田"
        className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 text-background-100 hover:text-background-50 float-slow"
      >
        <i className="ri-arrow-down-double-line text-3xl" />
      </a>
    </section>
  );
}